import Button from '../../Button';
import FaIcon from '../../Icons/FaIcon';
import WidgetCard from '../WidgetCard';
import styles from './style.module.scss';
function NextWeekJudicialCalendarWidget() {
    return (
        <WidgetCard title="Audience de la semaine">
            <ul>
                <li>
                    <Button
                        variant="secondaryLight"
                        className={styles.widgetMsg}
                    >
                        <FaIcon>fa-clock</FaIcon>
                        <span>Rdv avec M.XXX yyyy dans 1h</span>
                    </Button>
                </li>
                <li>
                    <Button
                        variant="secondaryLight"
                        className={styles.widgetMsg}
                    >
                        <FaIcon>fa-clock</FaIcon>
                        <span>Rdv avec M.XXX xxxx dans 3h</span>
                    </Button>
                </li>
                <li>
                    <Button
                        variant="secondaryLight"
                        className={styles.widgetMsg}
                    >
                        <FaIcon>fa-clock</FaIcon>
                        <span>Audience dans 4h</span>
                    </Button>
                </li>
                <li>
                    <Button
                        variant="secondaryLight"
                        className={styles.widgetMsg}
                    >
                        <FaIcon>fa-clock</FaIcon>
                        <span>Rdv avec M.XYX yyxxy dans 6h</span>
                    </Button>
                </li>
            </ul>
        </WidgetCard>
    );
}

export default NextWeekJudicialCalendarWidget;
